// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils_Logging$LiveRoom from "./Utils_Logging.bs.js";
import * as ClientapiQueries$LiveRoom from "../ClientapiQueries.bs.js";

function checkForAutochargePaymentMethod(auctionId, accountId, saleLocation, apolloClient, tapOk, tapNoPaymentMethod) {
  var $$let = ClientapiQueries$LiveRoom.Autocharge.AuctionAutochargeConfig;
  return Js_promise.then_((function (res) {
                if (res.TAG !== /* Ok */0) {
                  return Promise.resolve(Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                          hd: [
                                            "err",
                                            Belt_Option.getWithDefault(JSON.stringify(res._0), "")
                                          ],
                                          tl: /* [] */0
                                        })), undefined, undefined, "Failed fetching auto charge config for auction: " + auctionId + ""));
                }
                if (!res._0.data.auctionAutochargeConfig.eligibleForAutocharge) {
                  return Promise.resolve(Curry._1(tapOk, undefined));
                }
                if (accountId === undefined) {
                  return Promise.resolve(Utils_Logging$LiveRoom.log(undefined, undefined, undefined, "Error fetching auto charge payment method - no account id provided"));
                }
                if (saleLocation === undefined) {
                  return Promise.resolve(Utils_Logging$LiveRoom.log(undefined, undefined, undefined, "Error fetching auto charge payment method - no sale location provided"));
                }
                var $$let = ClientapiQueries$LiveRoom.Autocharge.AutochargePaymentMethodQuery;
                return Js_promise.then_((function (res) {
                              if (res.TAG === /* Ok */0) {
                                return Promise.resolve(res._0.data.addAutoChargePaymentMethodRequired.required ? Curry._1(tapNoPaymentMethod, undefined) : Curry._1(tapOk, undefined));
                              } else {
                                return Promise.resolve(Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                                        hd: [
                                                          "err",
                                                          Belt_Option.getWithDefault(JSON.stringify(res._0), "")
                                                        ],
                                                        tl: /* [] */0
                                                      })), undefined, undefined, "Error fetching auto charge payment method"));
                              }
                            }), Curry._6(apolloClient.rescript_query, {
                                query: $$let.query,
                                Raw: $$let.Raw,
                                parse: $$let.parse,
                                serialize: $$let.serialize,
                                serializeVariables: $$let.serializeVariables
                              }, undefined, undefined, undefined, undefined, Curry._3(ClientapiQueries$LiveRoom.Autocharge.AutochargePaymentMethodQuery.makeVariables, accountId, saleLocation, undefined)));
              }), Curry._6(apolloClient.rescript_query, {
                  query: $$let.query,
                  Raw: $$let.Raw,
                  parse: $$let.parse,
                  serialize: $$let.serialize,
                  serializeVariables: $$let.serializeVariables
                }, undefined, undefined, undefined, undefined, Curry._2(ClientapiQueries$LiveRoom.Autocharge.AuctionAutochargeConfig.makeVariables, auctionId, undefined)));
}

export {
  checkForAutochargePaymentMethod ,
}
/* Utils_Logging-LiveRoom Not a pure module */
